import React, { Suspense } from "react";
import tw from "twin.macro";
import '../../../styles/ThanishqStyle.css'




const AcrossCategories = React.lazy(() =>
  import("./AcrossCategories.js")
)

const Unbound = React.lazy(() =>
  import("./Unbound.js")
)
const NaturalDiamond = React.lazy(() =>
  import("./NaturalDiamond.js")
)
const LegazySince = React.lazy(() =>
  import("./LegazySince.js")
)



const Container = tw.div`relative overflow-hidden`;
export default () => {

  return (
    <Container >
      <Suspense  fallback={<>Loading...</>}>
        <Unbound />
      </Suspense>
      <Suspense fallback={<>Loading...</>}>
        <NaturalDiamond />
      </Suspense>
      {/* <Suspense fallback={<>Loading...</>}>
        <LegazySince />
      </Suspense> */}
      {/* <Suspense fallback={<>Loading...</>}>
        <AcrossCategories />
      </Suspense> */}
    </Container>
  );
};
